import { connect } from 'react-redux';

import DashboardModals from '../../components/purchase-dashboard/modals';
import {
  hideAutoPilotModal,
  hideInviteModal,
  hideInviteConfirmationModal,
  hideMakeChangesModal,
  hideCancelPurchaseModal,
  hideWithdrawModal,
  hideCommitModal,
  hideEditCommitModal,
  hideCoverDifferenceModal,
  hideRemoveModal,
  hideResolveIssuesModal,
  hideImageMagnifierModal,
} from '../../actions/ui';

const mapStateToProps = ({ purchases, ui }) => {
  return {
    purchase: purchases.byId[purchases.current],
    isAutoPilotModalVisible: ui.modals.autoPilot,
    isAutoPilotOnModalVisible: ui.modals.autoPilotOn,
    isInvitePeopleModalVisible: ui.modals.invite,
    isInviteConfirmationModalVisible: ui.modals.inviteConfirmation,
    isMakeChangesModalVisible: ui.modals.makeChanges,
    isCancelPurchaseModalVisible: ui.modals.cancelPurchase,
    isWithdrawModalVisible: ui.modals.withdraw,
    isCommitToPurchaseVisible: ui.modals.commit,
    isEditCommitVisible: ui.modals.editCommit,
    isCoverDifferenceVisible: ui.modals.coverDifference,
    isRemoveModalVisible: ui.modals.remove,
    isResolveIssuesModalVisible: ui.modals.resolveIssues,
    isImageMagnifierModalVisible: ui.modals.imageMagnifier,
  };
};

const mapDispatchToProps = {
  hideAutoPilotModal,
  hideInviteModal,
  hideInviteConfirmationModal,
  hideMakeChangesModal,
  hideCancelPurchaseModal,
  hideWithdrawModal,
  hideCommitModal,
  hideEditCommitModal,
  hideCoverDifferenceModal,
  hideRemoveModal,
  hideResolveIssuesModal,
  hideImageMagnifierModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardModals);



// WEBPACK FOOTER //
// ./src/desktop/containers/purchase-dashboard/modals.container.js